import React from 'react';
import {Link} from 'react-router-dom'
import {Modal, Button} from 'react-bootstrap'


String.prototype.lpad = function(padString, length) {
    var str = this;
    while (str.length < length)
        str = padString + str;
    return str;
}

export function InvoiceSerialGenerator(props){

  let settingOptions = props.options
  let series_name = props.series_name
  let series_counter = props.series_counter

  let final_string
  if (settingOptions && settingOptions.max_prefix_zeros) {
    let requiredZeros = parseInt(settingOptions.max_prefix_zeros)
    if(requiredZeros){

       let Character = settingOptions.counter_padding_char ? settingOptions.counter_padding_char : "0"

        final_string =  series_name + (series_counter+'').lpad(Character, requiredZeros)

        if(settingOptions['append_series_name_as_suffix']) {
          final_string =   (series_counter+'').lpad(Character, requiredZeros) + series_name
        }

    }
    else {
      final_string = props.series_name + props.series_counter
      if(settingOptions['append_series_name_as_suffix']) {
        final_string =  props.series_counter + props.series_name
      }
    }

  }
  else {
    final_string = props.series_name + props.series_counter
    if(settingOptions['append_series_name_as_suffix']) {
      final_string =  props.series_counter + props.series_name
    }
  }

  return final_string
}

export function SimpleInvoice(props){


  return <div className="panel panel-default">
            <div className="panel-body">
              <h4>#{props.serial}</h4>
              <div>
                {props.client.name}
              </div>
              <div className="panel-footer">
                {props.date}
              </div>
            </div>
    </div>

}

export class AddInvoiceButton extends React.Component {
  render() {
    return (<Link to="/invoices/create" className="btn btn-primary">Create New Invoice
  </Link>)

  }
}



export function InvoiceFinalBill(props) {

  const parentState = props.state
  const gsts = props.gsts

  let mrp = parentState.mrp, selling_price = parentState.selling_price, gst=parentState.gst

  let statement
  if (typeof gst !== "undefined" && typeof mrp !== "undefined") {
      let gst_object
      gsts.forEach((g,i)=>{
        if(g.id === gst) {
          gst_object = g
          const gstPct = gst_object.type === "I" ? gst_object.igst : (gst_object.cgst + gst_object.sgst)

          let basicRate

          let calculatedFinalPrice

          basicRate = basicRate(selling_price, gstPct)


          calculatedFinalPrice = basicRate + (basicRate * gstPct/100)
          calculatedFinalPrice = parseFloat(calculatedFinalPrice).toFixed(2)


          statement = <ul className="list-inline">
                      <li>{"Taxable Price (" + basicRate + ")"}</li>
                      <li>{gst_object.name}</li>
                      <li>{"Final Price " + calculatedFinalPrice}</li>
                    </ul>
        return statement
        }
      })

      return null

  }
  else {
    return null
  }


}

export class DeleteInvoiceButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.state = {show: false}
  }
  handleDelete() {
    this.setState({show:false})
    this.props.handleDelete()
  }
  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    const selectedRows = this.props.selectedRows

    let show = this.state.show
    let btn
    if(typeof this.props.invoice.deleting_invoices !== "undefined" && this.props.invoice.deleting_invoices) {
      show = false
      btn =   <button className="btn btn-danger" disabled>Deleting... </button>
    }
    else {
      btn = (<button className="btn btn-danger" onClick={this.handleShow}>Delete {selectedRows.length}</button>)
    }




    const modal = (
        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header closeButton>
           <Modal.Title>Confirm Delete</Modal.Title>
         </Modal.Header>
          <Modal.Body>
            Total {selectedRows.length} {selectedRows.length === 1 ? "row": "rows" } selected
          </Modal.Body>
          <Modal.Footer>
           <Button onClick={this.handleClose}>Close</Button>
           <Button onClick={this.handleDelete} bsStyle="danger">Delete</Button>
         </Modal.Footer>
        </Modal>
    )

    if(selectedRows.length > 0) {
      return (
        <span>
          {modal}
          {btn}

      </span>

)
    }
    return null

  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/utils.js